import React from 'react'
// libs
import moment from 'moment/moment'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector, getFormSyncErrors } from 'redux-form'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { DATE_FORMAT_OPTIONS } from 'constants/objects'
// types
import { IOption } from 'components/FormElements/Select'
// utils
import { required, validDateFormat } from 'utils/validators'
import { getDefaultDateFormat } from 'utils/date'

const DateFormatPreview = styled.span`
  font-size: 14px;
  margin-top: -12px;
  color: dimgray;
`

const selector = formValueSelector(Forms.PROPERTY_EDIT_FORM)

const DateSettings: React.FC = () => {
  const dispatch = useDispatch()

  const dateFormat = useSelector((state) => selector(state, 'settings.dateFormat'))

  // @ts-ignore
  const formatError = useSelector((state) => getFormSyncErrors(Forms.PROPERTY_EDIT_FORM)(state))?.settings?.dateFormat

  const onTypeChange = (type: IOption) => {
    dispatch(change(Forms.PROPERTY_EDIT_FORM, 'settings.dateFormat', getDefaultDateFormat(type.value)))
  }

  return (
    <>
      <ReduxSelect
        label='Date Type'
        validate={required}
        name='settings.format'
        onSelectChange={onTypeChange}
        options={DATE_FORMAT_OPTIONS}
      />
      <ReduxInput name='settings.dateFormat' label='Format' validate={[required, validDateFormat]} />
      {!formatError && <DateFormatPreview>{moment().format(dateFormat)}</DateFormatPreview>}
    </>
  )
}

export default DateSettings
